module.exports = __webpack_public_path__ + "img/howto_insurancestaking_metamaskstake.c7776a96.png";